export function decodeURIComponentSafe (uriComponent = "") {
	if (uriComponent == null) {
		console.error("decodeURIComponentSafe: null/undefined input");

		return uriComponent;
	}
	try {
		const str = String(uriComponent);
		const sanitized = str.replace(/%(?![0-9A-Fa-f]{2})/g, "%25");

		return decodeURIComponent(sanitized);
	} catch (err) {
		console.error(err.message);

		return uriComponent;
	}
}

export function decodeString (string) {
	try {
		return decodeURI(string);
	   } catch (e) {
		return string;
	}
}

